import { apiClient } from '../../services/apiClient';

const API_URL = import.meta.env.VITE_API_URL || '/api';

export type FeedbackTopic =
  | 'General'
  | 'Recipes'
  | 'Cookbooks'
  | 'Ingredients'
  | 'WeeklyPlanner'
  | 'ShoppingList';

export interface CreateFeedbackPayload {
  topic: FeedbackTopic;
  stars: number;
  comment?: string | null;
  thingsToImprove?: string | null;
  whatYouMiss?: string | null;
  isAnonymous?: boolean;
}

export interface FeedbackUser {
  id: string;
  email: string;
  username: string | null;
}

// ─── User: Submit feedback ────────────────────────────────────────────────────

export async function submitFeedback(payload: CreateFeedbackPayload): Promise<void> {
  await apiClient.post(`${API_URL}/feedback`, payload);
}
